export default function getAppliedFilterText(appliedFilters) {
  const filterApplied = appliedFilters.length > 0;
  const filterInfo = appliedFilters.length > 1 ? `(${appliedFilters.length})` : appliedFilters[0];
  return filterApplied ? `: ${filterInfo}` : '';
}
